import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Address } from 'src/app/models/address.model';

@Component({
  selector: 'choose-address',
  templateUrl: './choose-address.component.html',
  styleUrls: ['./choose-address.component.less']
})
export class ChooseAddressComponent implements OnInit {
  @Input() addressList: Address[] = []; 
  @Input() isTemporary: boolean=false; 
  @Output() addressSelected: EventEmitter<Address> = new EventEmitter<Address>();
  @Output() handleCloseAddress: EventEmitter<string> = new EventEmitter<string>();
  tabSelectedIndex: number = 0
  
  constructor(private translate:TranslateService) { }

  ngOnInit(): void {
    this.tabSelectedIndex= this.isTemporary===true?1:0;
  }

  chooseAddress(index:number):void{
    this.addressList.forEach((address, i) => {
      if (i === index) {
        address.isChoose = !address.isChoose;
      } else {
        address.isChoose = false;
      }
    });
  }

  onTabChange(index: number) {
    this.tabSelectedIndex = index;
  }

    //choose address
    handleAddressSelected(address:Address): void {
      this.addressSelected.emit(address);
    }
    //close the modal box for choosing address
    handleCloseModal(): void {
      this.handleCloseAddress.emit();
    }

  saveAddress(){
    // const chosenAddress = this.addressList.find(address => address.isChoose);
    // if (chosenAddress) {
    //   this.addressSelected.emit(chosenAddress);
    // } else {
    //   this.message.create('warning', 'Please choose an address');
    // }
    
  }

}
